<template>
  <div>
    <el-dialog
      :title="getTitle()"
      :visible.sync="accountAdjustmentFlag"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
      top="70px"
      style="text-align: center"
    >
      <el-form
        ref="addServicesForm"
        :model="addForm"
        :rules="formRules"
        label-width="120px"
      >
        <el-form-item label="客户货主" prop="orgID">
          <!-- <el-input v-model="addForm.orgID" disabled></el-input> -->
          <el-select
            v-model="addForm.orgID"
            :disabled="addServicesType != 'homeAdd'"
            style="width: 100%"
            placeholder="请选择客户货主"
          >
            <el-option
              v-for="item in orgIdsList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="addServicesFormLine">
          <el-form-item label="仓库" prop="wareHouseID">
            <!-- <el-input v-model="addForm.wareHouseID" disabled></el-input> -->
            <el-select
              @change="changeWare"
              v-model="addForm.wareHouseID"
              style="width: 100%"
              :disabled="addServicesType != 'homeAdd'"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 编辑的时候是单选，但传参还是传数组 -->
          <el-form-item label="增值服务类型" prop="feeTypeList">
            <el-select
              v-model="addForm.feeTypeList"
              :multiple="addServicesType == 'edit' ? false : true"
              :disabled="
                addServicesType === 'markComplete' || addServicesType == 'view'
              "
              style="width: 100%"
              placeholder="请先选择仓库"
            >
              <el-option
                v-for="item in feeTypeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="addServicesFormLine">
          <el-form-item label="关联单号" prop="relationNumber">
            <el-input
              v-model="addForm.relationNumber"
              :disabled="addServicesType != 'homeAdd'"
              :placeholder="inputPlaceholder"
              @blur="onInputBlur"
              ref="inputRelation"
            ></el-input>
          </el-form-item>
          <el-form-item label="期望完成时间" prop="ECTime">
            <el-date-picker
              v-model="addForm.ECTime"
              :disabled="
                addServicesType === 'markComplete' || addServicesType == 'view'
              "
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <template
          v-if="addServicesType == 'homeAdd' || addServicesType == 'edit'"
        >
          <el-form-item label="" style="margin-left: -890px">
            <el-button type="primary" @click="importExport">上传附件</el-button>
            <span style="color: blue"> {{ uploadText }}</span>
          </el-form-item>
        </template>
        <el-form-item :label="boxLabel" prop="BoxInfo">
          <el-input v-model="addForm.boxInfo" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="操作说明" prop="ServicesRemark">
          <el-input
            v-model="addForm.ServicesRemark"
            :disabled="
              addServicesType == 'view'
            "
            type="textarea"
          ></el-input>
        </el-form-item>
        <template v-if="addServicesType !== 'homeAdd'">
          <span
            v-if="
              (addServicesType !== 'add' && addServicesType !== 'edit') ||
              addServicesType == 'view'
            "
          >
            <div class="addServicesFormLine">
              <el-form-item label="实际操作数量" prop="doneQty">
                <el-input
                  v-model="addForm.doneQty"
                  type="number"
                  :disabled="addServicesType == 'view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="实际完成时间" prop="doneTime">
                <el-date-picker
                  v-model="addForm.doneTime"
                  type="date"
                  :disabled="addServicesType == 'view'"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <!-- 增值服务类型为其他时显示 -->
            <div class="addServicesFormLine" v-if="addForm.isOther">
              <el-form-item label="实际费用" prop="amount">
                <el-input
                  v-model="addForm.amount"
                  type="number"
                  :disabled="addServicesType == 'view'"
                ></el-input>
              </el-form-item>
              <el-form-item label="币种" prop="currency">
                <el-select
                  v-model="addForm.currency"
                  style="width: 100%"
                  filterable
                  :disabled="addServicesType == 'view'"
                  placeholder="请选择币种"
                >
                  <el-option
                    v-for="item in currencyList"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item label="仓库备注" prop="doneRemark">
              <el-input
                v-model="addForm.doneRemark"
                :disabled="addServicesType == 'view'"
                type="textarea"
              ></el-input>
            </el-form-item>
          </span>
        </template>
        <template v-if="addServicesType == 'markComplete'">
          <span>
            <el-form-item label="" style="margin-left: -890px">
              <el-button type="primary" @click="addReadyImages()"
                >上传图片</el-button
              >
              <span style="color: blue"> {{ uploadPic }}</span>
            </el-form-item>
          </span>
        </template>
        <el-form-item v-if="addServicesType !== 'view'">
          <el-button
            type="primary"
            v-if="addServicesType === 'add' || addServicesType === 'homeAdd'"
            @click="onSubmit(10)"
            :loading="addLoading"
            v-no-more-click
            >提交</el-button
          >
          <el-button
            type="primary"
            @click="onSubmit(0)"
            :loading="addLoading"
            v-no-more-click
            >保存</el-button
          >
          <el-button
            @click.native="accountAdjustmentFlag = false"
            :loading="addLoading"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 导入箱明细 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传附件"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".pdf"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传pdf文件</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload">确认提交</el-button>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <span style="color: red"> {{ Importtext }}</span>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 上传图片 -->
    <el-dialog
      :visible.sync="importPicture"
      v-model="importPicture"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传操作图片"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              class="upload-demo"
              action="string"
              multiple
              accept=".jpg"
              :limit="10"
              drag
              :file-list="fileList"
              :before-remove="beforeRemove"
              :on-change="onChange"
              :http-request="httpRequest"
              :on-remove="onRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传图片</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- :http-request="UploadBoxMarkExcel" -->
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <!-- <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载打包数据</el-button
            >
          </el-form-item> -->
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="UploadBoxMarkExcel"
              >确定上传</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>


  
<script>
import {
  CompleteServices,
  GetFeeType,
  AddServices,
  UploadAddServiceFile,
  GetBoxInfo,
} from "@/api/AddServices/index.js";
import {
  GetCurrencyServiceModelList,
  getCustomerList,
} from "@/api/common/common.js";
import { arrToJoin, toSelectOptions, getSearchDataIndex } from "util/util";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
export default {
  props: ["addServicesType"],
  data() {
    return {
      warehouseList: [],
      orgIdsList: [],
      currencyList: [],
      feeTypeList: [],
      fileList: [],
      addForm: {},
      boxLabel:"箱号(箱数)",
      accountAdjustmentFlag: false,
      addLoading: false,
      importVisible: false,
      progressFlag: false,
      importPicture: false,
      progressPercent: 0,
      inputPlaceholder:"请输入关联单号",
      Importtext: "",
      DonePics: "",
      uploadText: "",
      uploadPic: "",
      uploadUrl: "",
      expensesList: [],
      formRules: {
        orgID: [{ required: true, message: "请输入客户货主", trigger: "blur" }],
        wareHouseID: [
          { required: true, message: "请输入仓库", trigger: "blur" },
        ],
        feeItemName: [
          { required: true, message: "请输入费用项", trigger: "blur" },
        ],
        feeTypeList: [
          { required: true, message: "请选择增值服务", trigger: "blur" },
        ],
        ServicesRemark: [
          { required: true, message: "请输入操作说明", trigger: "blur" },
        ],
        doneQty: [
          { required: true, message: "请输入实际操作数量", trigger: "blur" },
        ],
        doneTime: [
          { required: true, message: "请输入实际完成时间", trigger: "blur" },
        ],
        amount: [
          { required: true, message: "请选择实际费用", trigger: "blur" },
        ],
        currency: [{ required: true, message: "请选择币种", trigger: "blur" }],
      },
    };
  },
  methods: {
    onInputBlur(event) {
      // 在这里处理输入框焦点离开事件
      const inputValue = event.target.value;
      if(inputValue!='')
      {
      this.getBoxInfo(0,inputValue);
      }
    },
    onChange(file, fileList) {
      this.fileList = fileList;
      console.log(this.fileList);
    },
    httpRequest(param) {
      // this.fileList.push(param.file)
      console.log(param);
    },
    //移除图片
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    addReadyImages() {
      this.fileList = [];
      this.uploadPic = "";
      this.importPicture = true;
    },
    //上传操作图片
    UploadBoxMarkExcel(file) {
      let para = new FormData();
      this.uploadPic = "";
      for (var i = 0; i < this.fileList.length; i++) {
        console.log(this.fileList[i].size);
        if (this.fileList[i].size > 10 * 1024 * 1024) {
          this.$message({
            message:
              "文件" + this.fileList[i].name + "不能大于10M，请选择小的文件",
            type: "error",
          });
          return false; //必须返回false
        }
        para.append("file", this.fileList[i].raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
        para.append("fileName", this.fileList[i].name);
        this.uploadPic = this.uploadPic + this.fileList[i].name + ",";
      }
      this.uploadPic.substring(0, this.uploadPic.length - 1);

      console.log(para);
      //para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url: UploadAddServiceFile,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.importPicture = false;
            //param.onError(); // 上传成功的文件会显示绿色的对勾
            this.DonePics = res.data.response.join(",");
            console.info(this.DonePics);
            this.$message({
              message: "上传成功,请保存",
              type: "success",
            });
          } else {
            this.$message({
              message: "上传失败",
              type: "error",
            });
            //param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          //param.onError();
        });
    },
    getTitle() {
      let title = "";
      if (
        this.addServicesType === "add" ||
        this.addServicesType === "homeAdd"
      ) {
        title = "新增";
      } else if (this.addServicesType === "edit") {
        title = "修改";
      } else if (this.addServicesType === "markComplete") {
        title = "标记完成";
      } else if (this.addServicesType === "view") {
        title = "查看";
      }
      return title;
    },
    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "pdf";
      if (!extension) {
        this.$message({
          message: "导入文件只能是pdf格式!",
          type: "error",
        });
      }
      return extension;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    //上传文件
    UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }
      console.log(param, "文件");
      this.uploadText = param.file.name;
      this.parafile = param;
      let para = new FormData();
      para.append("files", param.file);
      this.progressFlag = true;
      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            this.parafile = "";
            console.log(res.data);
            this.uploadUrl = res.data.response[0].urlPath;
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    changeWare(val) {
      if(val==2)
      {
        this.inputPlaceholder="请填写FH单号";
        this.boxLabel="数量";
      }
      else
      {
        this.inputPlaceholder="请填写RQD单号";
        this.boxLabel="箱号(箱数)";
      }
      this.getFeeType(val, true);
    },
    getFeeType(warehouseIds, needClear) {
      GetFeeType({
        type: 4,
        warehouseIds,
      }).then((res) => {
        this.feeTypeList = toSelectOptions(
          res.response,
          "feeTypeID",
          "feeTypeName"
        );
        if (needClear) {
          this.$set(this.addForm, "feeTypeList", []);
        }
      });
    },
    getBoxInfo(tfAddServicesID,relationOrdeNo) {
      GetBoxInfo({
        tfAddServicesID,
        relationOrdeNo,
      }).then((res) => {
        this.$set(this.addForm, "boxInfo", res.msg);
      });
    },
    showDalog(data) {
      console.info(data);
      // 设置增值服务类型下拉
      if (data) {
        this.getFeeType(data.wareHouseID);
      }
      if (this.addServicesType == "homeAdd") {
        this.addForm = {};
        if (this.warehouseList.length && this.warehouseList.length == 1) {
          this.$set(this.addForm, "wareHouseID", this.warehouseList[0].value);
          this.getFeeType(this.warehouseList[0].value);
        }
      } else if (this.addServicesType === "add") {
        let { orgID, wareHouseID, deliveryOrdeNo, isOther } = data;
        this.addForm = {
          orgID,
          wareHouseID,
          relationNumber: deliveryOrdeNo,
          isOther,
          feeTypeList: [],
        };
      } else if (
        this.addServicesType === "edit" ||
        this.addServicesType === "markComplete"
      ) {
        let {
          orgID,
          wareHouseID,
          relationNumber,
          ecTimeText,
          servicesRemark,
          tfAddServicesID,
          servicesType,
          relationID,
          isOther,
          fileUrl,
          boxInfo,
        } = data;
        this.addForm = {
          orgID,
          wareHouseID,
          relationNumber,
          ECTime: ecTimeText,
          ServicesRemark: servicesRemark,
          tfAddServicesID,
          relationID,
          isOther,
          boxInfo,
          feeTypeList:
            this.addServicesType === "markComplete"
              ? [servicesType]
              : servicesType,
        };
        this.uploadUrl = fileUrl;
      } else if (this.addServicesType === "view") {
        let {
          orgID,
          wareHouseID,
          relationNumber,
          ecTimeText,
          servicesRemark,
          tfAddServicesID,
          servicesType,
          relationID,
          doneQty,
          doneTime,
          amount,
          doneRemark,
          currency,
          isOther,
          boxInfo,
        } = data;
        this.addForm = {
          orgID,
          wareHouseID,
          relationNumber,
          ECTime: ecTimeText,
          ServicesRemark: servicesRemark,
          tfAddServicesID,
          relationID,
          feeTypeList: [servicesType],
          doneQty,
          amount,
          doneRemark,
          doneTime,
          currency,
          isOther,
          boxInfo,
        };
      }
      this.accountAdjustmentFlag = true;
      if(this.addForm.relationNumber!=undefined)
      {
        this.getBoxInfo(this.addForm.tfAddServicesID,this.addForm.relationNumber);   
      }
      
    },
    onSubmit(status) {
      this.$refs.addServicesForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.addForm);
          this.addLoading = true;
          params.ServiceStatus = status; // 新增、提交状态码
          if (this.addServicesType === "edit") {
            params.feeTypeList = [params.feeTypeList];
          }
          let service = AddServices;
          if (this.addServicesType === "markComplete") {
            service = CompleteServices;
          }

          this.$set(params, "attachmentUrl", this.uploadUrl);
          this.$set(params, "uploadPicUrl", this.DonePics);
          service(params).then((res) => {
            this.addLoading = false;
            if (res.data.success) {
              this.$refs["addServicesForm"].resetFields();
              this.$message({
                message: res.data.msg || "操作成功",
                type: "success",
              });
              this.accountAdjustmentFlag = false;
              this.$emit("searchTable", "");
            } else {
              this.$message({
                message: res.data.msg || "操作失败",
                type: "error",
              });
            }
          });
        }
      });
    },
    // 获取搜索栏下拉框数据
    initDropList() {
      // 设置仓库下拉
      let user = JSON.parse(window.localStorage.user);
      this.warehouseList = toSelectOptions(
        user.warehouseList,
        "warehouseId",
        "warehouseName"
      );

      // 设置客户下拉
      getCustomerList({}).then((res) => {
        this.orgIdsList = toSelectOptions(
          res.data.response,
          "id",
          "customName"
        );
      });
    },

    //弹出导入文件框
    importExport() {
      this.importVisible = true;
    },
  },
  mounted() {
    GetCurrencyServiceModelList({}).then((res) => {
      this.currencyList = toSelectOptions(
        res.data.response,
        "currencyValue",
        "currencyName"
      );
    });
    // 获取搜索栏下拉框数据
    this.initDropList();
    this.fileList = [];
    this.uploadPic = "";
  },
};
</script>

<style lang="less" scoped>
.addServicesFormLine {
  display: flex;

  > div {
    width: 49.5%;
  }

  > div:first-child {
    margin-right: 1%;
  }

  .el-date-editor.el-input {
    width: 100%;
  }
}
.feeTypeListTip {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 29px;
  font-size: 10px;
  color: red;
}
</style>
  
  